<style lang="scss">
  @import "./Header.scss";
</style>

<div class="header-container">
  <header>
    <h1>Meetups</h1>
  </header>
</div>